import urlBuilder from '../../utils/urlBuilder';

const mapCompanySummaryToTable = (companySummary, translation) => {
    const dataCols = [
        {
            id: 'company', numeric: false, disablePadding: false, label: translation.COMPANY, defaultSorting: false,
        },
        {
            id: 'city', numeric: false, disablePadding: false, label: translation.CITY, defaultSorting: false,
        },
        {
            id: 'lead', numeric: true, disablePadding: false, label: translation.LEADS, defaultSorting: false,
        },
        {
            id: 'click', numeric: true, disablePadding: false, label: translation.CLICK, defaultSorting: false,
        },
        {
            id: 'impression', numeric: true, disablePadding: false, label: translation.IMPRESSIONS, defaultSorting: true,
        },
        {
            id: 'link', numeric: false, disablePadding: false, label: translation.LINK, defaultSorting: false, disableSorting: true, link: true,
        },
    ];

    const dataRows = companySummary.map(company => ({
        id: company.hid,
        company: company.name,
        city: company.city,
        lead: company.lead,
        click: company.click,
        impression: company.impression,
        link: urlBuilder.getHittaCompanyUrl(company.hid),
    }));

    return {
        dataCols,
        dataRows,
    };
};

const mapProductSummaryToTable = (productSummary, translation) => {
    const dataCols = [
        {
            id: 'product', numeric: false, disablePadding: false, label: translation.PRODUCT, defaultSorting: false,
        },
        {
            id: 'lead', numeric: true, disablePadding: false, label: translation.LEADS, defaultSorting: false,
        },
        {
            id: 'ctr', numeric: true, disablePadding: false, label: translation.CTR, defaultSorting: false,
        },
        {
            id: 'click', numeric: true, disablePadding: false, label: translation.CLICK, defaultSorting: false,
        },
        {
            id: 'impression', numeric: true, disablePadding: false, label: translation.IMPRESSIONS, defaultSorting: true,
        },
    ];

    const dataRows = productSummary.map((product) => {
        const ctr = Math.round(product.click * 10000 / product.impression) / 100;

        return {
            id: product.name,
            product: translation.PRODUCT_KEYS[product.name] || product.name,
            lead: product.lead,
            ctr: Number.isNaN(ctr) ? '-' : `${ctr}%`,
            click: product.click,
            impression: product.impression,
        };
    });

    return {
        dataCols,
        dataRows,
    };
};

export {
    mapCompanySummaryToTable,
    mapProductSummaryToTable,
};
